import { render, staticRenderFns } from "./list-form-top.vue?vue&type=template&id=2c2120c6"
import script from "./list-form-top.vue?vue&type=script&lang=js"
export * from "./list-form-top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports